var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { createDom } from "../domUtils.mjs";
import { BasePopup } from "./BasePopup.mjs";
const enLocaleStrings = {
  agree: "AGREE",
  body: `<p>We've updated our <a href="https://www.play.co/tos">Terms</a> and <a href="https://play.co/privacy">Privacy Notice</a>. Learn about <a href="http://www.play.co/press/updates-to-terms-and-privacy-notice-dec-2022">what's changed</a>.</p><p>By continuing to play, you agree to the new terms and acknowledge you've read the privacy notice.</p>`
};
const localeStrings = {
  en: enLocaleStrings,
  ja: {
    agree: "同意する",
    body: `<p>当社は<a href="https://www.play.co/tos">利用規約</a> 及び<a href="https://play.co/privacy">プライバシー通知</a> を更新しました。<a href="http://www.play.co/press/updates-to-terms-and-privacy-notice-dec-2022">変更点について</a> をご確認ください。</p><p>プレーを継続することで、お客様は新たな規約に同意することになり、また、プライバシー通知を既に読んだことを認めることになります。</p>`
  }
};
class ToSPopup extends BasePopup {
  constructor() {
    super();
    __publicField(this, "_locale", "en");
    __publicField(this, "_useLegacyLinks", false);
    this.render();
  }
  get locale() {
    return this._locale;
  }
  set locale(locale) {
    const isValidLocale = locale === "en" || locale === "ja";
    if (isValidLocale && locale !== this._locale) {
      this._locale = locale;
      this.render();
    }
  }
  set useLegacyLinks(useLegacyLinks) {
    if (useLegacyLinks !== this._useLegacyLinks) {
      this._useLegacyLinks = useLegacyLinks;
      this.render();
    }
  }
  render() {
    const l = localeStrings[this._locale];
    const body = this._useLegacyLinks ? l.body.replace(
      "https://www.play.co/tos",
      "https://www.chobolabs.com/terms-of-service/"
    ).replace(
      "https://play.co/privacy",
      "https://www.chobolabs.com/privacy-policy/"
    ) : l.body;
    this.container.innerHTML = body;
    const confirmButton = createDom("button", "button", this.container);
    confirmButton.innerText = l.agree;
    confirmButton.onclick = () => this.closePopup();
  }
}
__publicField(ToSPopup, "ELEMENT_NAME", "tos-popup");
export {
  ToSPopup
};
